import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/* tailwind-merge nezná naši stupnici písma ani barevné *-text tokeny
 * (tailwind.config.js → theme.extend.fontSize / colors). Bez tohoto
 * rozšíření bere `text-drobny` za BARVU textu, takže
 *   cn("text-drobny text-[color:var(--muted)]") → "text-[color:var(--muted)]"
 * a velikost písma tiše zmizí. Tady ji zařadíme do skupiny font-size
 * (text-drobny text-maly → text-maly) a tokeny *-text výslovně mezi barvy.
 * Test: lib/__tests__/utils.test.js. */
export const VELIKOSTI_PISMA = ["popisek", "drobny", "maly", "text", "vetsi"];
export const BAREVNE_TEXT_TOKENY = ["money-text", "warn-text", "positive-text", "info-text", "negative-text"];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: VELIKOSTI_PISMA }],
      "text-color": [{ text: BAREVNE_TEXT_TOKENY }],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
